import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { PromptCreateService } from '../services/prompt-create.service';
import { CommonModule } from '@angular/common';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { DashboardService } from '../services/shared/dashboard.service';
import { MatSelectModule } from '@angular/material/select';
import { SaveSuccessComponent } from '../save-success/save-success.component';
import { ButtonComponent } from '../components/common/components/button/button.component';
import { SelectDropdownComponent } from '../components/common/components/select-dropdown/select-dropdown.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarComponent } from '../components/common/components/snack-bar/snack-bar.component';
import { ErrorNotficationComponent } from '../error-notfication/error-notfication.component';

@Component({
  selector: 'app-on-save',
  standalone: true,
  imports: [MatDialogModule, CommonModule, FormsModule, MatIconModule, MatSelectModule, ReactiveFormsModule, ButtonComponent, SelectDropdownComponent],
  templateUrl: './on-save.component.html',
  styleUrl: './on-save.component.scss'
})
export class OnSaveComponent {

  title: string = "";
  description = new FormControl();
  version_reason = new FormControl();
  notes = new FormControl();
  promptTitle = new FormControl();
  actionType: string = "add"
  cancelButtonText = "Cancel"
  selectedrating: number = -1;
  isSubmitDisabled: boolean = false;
  isCommentRequired: boolean = false;
  comments: string = '';
  selectedValue: number = 0;
  version: number = 0;
  allcategory: any;
  promptUserService: any;
  promptUserDetails: any;
  fileNames: any[] = [];
  promptCreatedBy: unknown;
  promptCategory: unknown;
  categories: any = [];
  subcategories: any = [];
  promptDetails: any;
  userid: any;
  category_id: any = [];
  sub_category_id: any = null;
  user_role: any;
  promptDetailsObj: any = [];
  titleRequired: boolean = false;
  lastSelectedTabIndex: number = 0;
  // category functionality
  isSaveClicked: boolean = false;
  category: any = null;
  subCategory: any = null;
  promptId: any = null;
  promptDetailsId: any = null;
  attch: any;
  permentattch: any;
  newAttachments: string[] = [];
  attachmentData: any;
  permentattchData: any;
  savePromptHeaderTitle: string = "Save Prompt";
  versionStatus: boolean = false;
  savePromptTitle: string = "Please complete the following mandatory fields manually to save your prompt."
  isInsert: boolean = false;
  forType: string = '';
  variant: number = 0;
  variant_reason = new FormControl('');
  latest_version: number = 0;
  subTitle = '';
  time: string = "00.00"
  timeFloat: number = 0.0


  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any, private snackBar: MatSnackBar,
    private dialogRef: MatDialogRef<OnSaveComponent>, private promptCreateService: PromptCreateService, private dialog: MatDialog, private dashboardService: DashboardService) {

    // this.dashboardService.currentData.subscribe((data:any) => {
    //   this.userid = data
    //   if (this.userid == 1) {
    //     this.user_role = "admin"
    //   }
    //   else if (this.userid == 2) {
    //     this.user_role = "curator"
    //   }
    //   else if (this.userid == 3) {
    //     this.user_role = "creator"
    //   }
    //   else if (this.userid == 4) {
    //     this.user_role = "user"
    //   }
    // });
    this.user_role = this.dashboardService.user_role
    this.userid = this.dashboardService.user_id;

    if (data) {
      
      this.attachmentData = data.attachment;
      this.permentattchData = data.perminentAttachments
      this.promptDetailsObj = data.promptData
      //this.title = data.title;
      this.actionType = data.action_typ
      // this.promptDetails = data.promptData
      this.attch = data.attachments,
        this.permentattch = data.perminentAttachments
      this.lastSelectedTabIndex = data?.selectedTabIndex;
      this.versionStatus = data?.versionStatus;
      this.version = this.data?.version;
      this.variant = this.data?.variant;
      this.forType = this.data?.forType;
      this.latest_version = this.data?.latest_version;

      if (data?.estimated_time) {
        let float_time = parseFloat(data?.estimated_time).toFixed(2);
        this.time = float_time;
        this.timeFloat = data?.estimated_time;
      }
      if ((this.versionStatus && this.forType == 'version') || (!this.versionStatus && this.version > 0)) {
        this.promptTitle.disable();
      } else if ((this.versionStatus && this.forType == 'variant') || (!this.versionStatus && this.variant > 0 && this.version == 0)) {
      }

     if(data?.estimated_time) {
      let float_time = parseFloat(data?.estimated_time).toFixed(2);
      this.time = float_time;
      this.timeFloat = data?.estimated_time;
     }
     if((this.versionStatus && this.forType == 'version') || (!this.versionStatus && this.version>0)){
      this.promptTitle.disable();
     }else if((this.versionStatus && this.forType == 'variant') || (!this.versionStatus && this.variant>0 && this.version == 0) ){
     
   }
     
      // this.category = data.category_id;
      data.categories.map((item: any) => {
        if (item.id == data.category_id) {
          this.category = {
            id: item.id,
            name: item.name,
            value: { ...item.value }
          }
          if (item.value?.subcategories.length > 0) {
            item.value?.subcategories.map((subItem: any) => {
              if (subItem.id == data.sub_category_id) {
                this.subCategory = {
                  ...subItem
                }
       
              }
            })
          }
        }
      });
      // this.subCategory = data.sub_category_id;
      this.description.setValue(data.description);
      if (this.versionStatus) {
        this.version_reason.setValue(''); //published only ask for reason just before draft. 
        this.variant_reason.setValue('');
      } else {
        this.version_reason.setValue(data.version_reason);
        this.variant_reason.setValue(data.variant_reason);
      }
      this.notes.setValue(data.notes);
      this.promptId = data.promptId;
      this.promptDetailsId = data.promptDetailsId;
      this.categories = data.categories
      this.subcategories = data.subcategories
      this.isInsert = data.isInsert
      //this.category_id = this.categories[0]?.id ?? null
      //this.subcategories =this.categories[0]?.value?.subcategories ? this.categories[0].value.subcategories : [] ;
      //this.category=this.categories.find((cat:any)=>cat.id == data?.category_id );
      //if(this.categories?.value.subcategories.length>0){
      //this.subCategory=this.subcategories.find((subcat:any)=>subcat.id == data?.sub_category_id );
      //this.subCategory={id:this.subCategory?.id,name:this.subCategory?.name,value:this.subCategory};
      //}
      // this.promptTitle.setValue(data.promptData[0]?.prompt_name);
      // if(data.title.value) {
      //   this.promptTitle.setValue(data.title.value);
     
      // }
      if (data.title && data.title != "Create Prompt") {
        this.promptTitle.setValue(data.title);
      }
      else if (data.promptData?.length > 1) {
        this.promptTitle.setValue("");
      } else {
        this.promptTitle.setValue(data.promptData[0]?.prompt_name);
      }

    }
    this.dialogRef.updateSize('300vw', '300vw')

    if (this.promptDetailsObj.length == 1) {
      this.savePromptHeaderTitle = "Save Prompt";
      this.savePromptTitle = "Please complete the following mandatory fields manually to save your prompt."
    } else if (this.promptDetailsObj.length > 1) {
      this.savePromptHeaderTitle = "Save Chain of Prompt";
      this.savePromptTitle = "Please complete the following mandatory fields manually to save your prompt chain."
    }
  }

  async ngOnInit() {
    this.user_role = this.dashboardService.user_role
    this.userid = this.dashboardService.user_id;


  }


  onClose() {
    this.dialogRef.close(false);
  }



  selectCategory(event: any) {
    // this.category_id = +(event.target as HTMLSelectElement).value
    // const selectedcat = this.category_id;
    // let a = this.categories.filter((cat:any)=>{
    //   if(cat.id == this.category_id){
    //     return cat
    //   }
    // });
    //  this.subcategories = a[0].value.subcategories;
    //  this.sub_category_id = this.subcategories[0]?.id;
    this.category = event;
    this.subCategory = null;
    this.subcategories = this.categories.find((category: any) => category.name === event.name)?.value?.subcategories ?? [];
  
    //this.subcategories = this.categories.find((category: any) => category.name === event.name)?.value?.subcategories?.map((subCategory: any) => ({name: subCategory.name, value: subCategory.id})) ?? [];
  }

  selectSubCategory(event: any) {
    // this.sub_category_id = +(event.target as HTMLSelectElement).value
    //this.subCategory = event;
    this.subCategory=this.subcategories.find((subcate: any) => subcate.name === event.name)
    this.subCategory={id:this.subCategory?.id,name:this.subCategory?.name,value:this.subCategory};

  }

  onTitleChange(event: any) {
    this.title = event.target.value;
    if (this.data?.promptData.length == 1 && this.data?.promptData[0]?.prompt_name) {
      this.data.promptData[0].prompt_name = this.title;
    }
  }

  onDescriptionChange($event: any){
   

  }
  onNoteChange($event: any){
  
  }

  private parseTime(): { hours: number, minutes: number } {
    const [h, m] = this.time.split(".").map(Number);
    return {
      hours: isNaN(h) ? 0 : Math.min(Math.max(h, 0), 99),
      minutes: isNaN(m) ? 0 : Math.min(Math.max(m, 0), 59)
    }
  }

  private formatTime(h: number, m: number): string {
    const hh = String(h).padStart(2, '0');
    const mm = String(m).padStart(2, '0');
    return `${hh}.${mm}`
  }

  increaseHour() {
    const { hours, minutes } = this.parseTime();
    const newHours = Math.min(hours + 1, 99);
    this.time = this.formatTime(newHours, minutes)
    this.timeFloat = parseFloat(this.time)
  }

  decreaseHour() {
    const { hours, minutes } = this.parseTime();
    const newHours = Math.max(hours - 1, 0);
    this.time = this.formatTime(newHours, minutes)
    this.timeFloat = parseFloat(this.time)
  }

  validateAndFormatTime() {
    const timePattren = /^(\d{1,2}).([0-5]\d)$/;
    let validTime = parseFloat(this.time).toFixed(2);
    const match = validTime.match(timePattren);

    if (match) {
      let hours = parseInt(match[1], 10);
      let minutes = parseInt(match[2], 10);

      if (hours > 99) hours = 99;
      if (minutes > 59) minutes = 59;

      this.time = this.formatTime(hours, minutes);
      this.timeFloat = parseFloat(this.time)
    } else {
      this.time = '00.00'; // fallback if invalid
      this.timeFloat = 0;
    }
  }

  // onSave(event: any) {
  //   this.isSaveClicked = false
  //   if (this.subCategory?.id) {
  //     this.subCategory = { id: this.subCategory?.id, name: this.subCategory?.name, value: this.subCategory };
  //   }
  //   if (!this.promptTitle.value || !this.category?.value || (this.category?.value?.subcategories?.length > 0 && this.subCategory == null) || (this.category?.value?.subcategories?.length > 0 && this.subCategory == undefined)) {
  //     this.isSaveClicked = true
  //     return; // Stop execution if validation fails
  //   }


  //   // if(this.forType == 'variant' &&  this.promptTitle.value == this.data.title){
  //   //   this.dialogRef?.close({});
  //   //   this.openSnackbar('title title should update.', 'Error Message', 'Error Message');
  //   //   return;
  //   // }

  //   if (this.forType == 'variant') {
  //     if (!this.variant_reason.value) {
  //       this.isSaveClicked = true
  //       return;
  //     }
  //   } else {
  //     if ((this.versionStatus || this.version > 0) && !this.version_reason.value) {
  //       this.isSaveClicked = true
  //       return;
  //     }

  //   }
  //   // if  (this.promptTitle.value == '' || this.category.value == null || (this.subcategories?.length > 0 && this.subCategory?.value == null)) {
  //   //   this.isSaveClicked = true
  //   //   return;
  //   // }

  //   // let obj = {

  //   //       "prompt_name": this.title,
  //   //       "prompt": this.promptDetails.promptDetails,
  //   //       "input": this.promptDetails.promptInput,
  //   //       "order_number": 1,
  //   //       "model_id": 2,
  //   //       "permanent_attachments": this.promptDetails.perminentAttachments?.map((attachment: any) => attachment?.name),
  //   //       "attachments": this.promptDetails.attachments?.map((attachment: any) => attachment?.name),
  //   //       "variables": [
  //   //         "c7",
  //   //         ["c7_1", "c7_2"]
  //   //       ]
  //   //     }

  //   if (this.versionStatus) {
  //     Object.keys(this.promptDetailsObj).forEach(key => {
  //       this.promptDetailsObj[key].prompt_detail_id = null;
  //     });
  //   }

  //   let request = {};

  //   //     this.promptDetailsObj.push(obj)
  //   if (this.forType == 'variant') {
  //     request = {
  //       "title": this.promptTitle.value,
  //       "description": this.description.value ?? '',
  //       "notes": this.notes.value ?? '',
  //       "category_id": this.category?.value?.id || this.category?.value,
  //       "sub_category_id": this.subCategory?.value?.id ?? null,
  //       "user_id": +this.userid,
  //       "prompt_type": this.promptDetailsObj.length == 1 ? "normal" : 'chain',
  //       "prompt_id": this.versionStatus ? null : this.promptId,//this.promptId ?? null, 
  //       "prompt_details": this.promptDetailsObj,
  //       //this.versionStatus?this.promptDetailsObj?.prompt_details?.forEach((data:any)=> {data.prompt_detail_id=null;}):this.promptDetailsObj,
  //       "lastselectedTabIndex": this.lastSelectedTabIndex,
  //       "variant": this.data?.variant + 1,
  //       "variant_reason": this.variant_reason.value ?? '',
  //       "variant_source": this.data?.promptId,
  //       "estimated_time": this.timeFloat
  //     }
  //   } else {
  //     request = {
  //       "title": this.promptTitle.value,
  //       "description": this.description.value ?? '',
  //       "notes": this.notes.value ?? '',
  //       "category_id": this.category?.value?.id || this.category?.value,
  //       "sub_category_id": this.subCategory?.value?.id ?? null,
  //       "user_id": +this.userid,
  //       "action_type": 'save',
  //       "prompt_type": this.promptDetailsObj.length == 1 ? "normal" : 'chain',
  //       "prompt_id": this.versionStatus ? null : this.promptId,//this.promptId ?? null, 
  //       "prompt_details": this.promptDetailsObj,
  //       //this.versionStatus?this.promptDetailsObj?.prompt_details?.forEach((data:any)=> {data.prompt_detail_id=null;}):this.promptDetailsObj,
  //       "lastselectedTabIndex": this.lastSelectedTabIndex,
  //       "version": this.versionStatus ? this.data?.latest_version + 1 : this.data?.version,
  //       "version_reason": this.version_reason.value ?? '',
  //       "source_prompt_id": this.data?.source_prompt_id,
  //       "source_version": this.data?.source_version,
  //       "variant": this.data?.variant,
  //       "variant_reason": this.data?.variant_reason ?? '',
  //       "variant_source": this.data?.variant_source_id,
  //       "estimated_time": this.timeFloat
  //     }

  //   }


  //   if (((this.versionStatus && this.forType == 'version') || (!this.versionStatus && this.version > 0))) {
  //     let version = this.versionStatus ? (this.data?.latest_version + 1) : this.data?.version;
  //     this.subTitle += ' version ' + version;
  //   } else if (this.forType == 'variant' || this.variant > 0) {
  //     this.subTitle += ' variant ' + (this.data?.variant + 1);
  //   }


  //   //return;
  //   // if  (this.promptTitle.value == '' || this.category.value == null || (this.subcategories?.length > 0 && this.subCategory?.value == null)) {
  //   //   this.isSaveClicked = true
  //   //   return;
  //   // } 
  //   if (this.promptDetailsObj) {


  //     this.promptCreateService.OnSave(request).subscribe(res => {
  //       if (res.status_code === 200) {
  //         this.promptCreateService.promptSaveResp$.next(res.data)

  //         let messageData;
  //         const variant = res?.data?.prompt?.variant;
  //         const version = res?.data?.prompt?.version;
  //         const promptTitle = this.promptTitle?.value;
  //         if (res?.data?.prompt?.estimated_time) {
  //           let float_time = parseFloat(res?.data?.prompt?.estimated_time).toFixed(2);
  //           this.time = float_time;
  //         }
  //         if (this.promptDetailsObj && this.promptDetailsObj.length > 1) {
  //           // messageData = `The prompt chain '${this.promptUserDetails?.title}' has been approved and published successfully`
  //           messageData = `The prompt chain `;
  //           if ((variant >= 1) && (version >= 1)) {
  //             messageData += `'${promptTitle} - Variant ${variant} Version ${version}'`;
  //           } else if ((variant >= 1) && (version < 1)) {
  //             messageData += `'${promptTitle} - Variant ${variant}'`;
  //           } else if ((version >= 1 && (variant < 1))) {
  //             messageData += `'${promptTitle} - Version ${version}'`;
  //           } else {
  //             messageData += `'${promptTitle}'`;
  //           }
  //           messageData += ' has been saved successfully';
  //         } else if (this.promptDetailsObj && this.promptDetailsObj.length == 1) {
  //           // messageData = `The prompt '${this.promptUserDetails?.title}' has been approved and published successfully`
  //           messageData = `The prompt `;
  //           if ((variant >= 1) && (version >= 1)) {
  //             messageData += `'${promptTitle} - Variant ${variant} Version ${version}'`;
  //           } else if ((variant >= 1) && (version < 1)) {
  //             messageData += `'${promptTitle} - Variant ${variant}'`;
  //           } else if ((version >= 1 && (variant < 1))) {
  //             messageData += `'${promptTitle} - Version ${version}'`;
  //           } else {
  //             messageData += `'${promptTitle}'`;
  //           }
  //           messageData += ' has been saved successfully';
  //         }

  //         const dialogRef = this.dialog.open(ErrorNotficationComponent, {
  //           data: {
  //             message: messageData,
  //             title: "Prompt Saved successfully",
  //             action_type: 'add',
  //             cssClass: 'success-snackbar'
  //           }
  //         });
  //         if (this.isInsert) {
  //           setTimeout(() => {
  //             dialogRef.close();
  //           }, 1000)
  //         }
  //         // const dialogRef = this.dialog.open(SaveSuccessComponent,{
  //         //   data:{
  //         //     message:this.promptTitle.value,
  //         //     title:"Prompt Saved successfully",
  //         //     action_type: 'save'
  //         //   }
  //         // }); 
  //         this.dialogRef?.close(res);
  //         // const preSignedUrlRequest = {
  //         //   prompt_id: res?.data?.prompt?.id,
  //         //   title: res?.data?.prompt?.title,
  //         //   url_type: 'put_object',
  //         //   prompt_details: res?.data?.prompt_details?.map((detail: any) =>
  //         //     ({
  //         //       prompt_detail_id: detail?.id,
  //         //       permanent_attachments: detail?.permanent_attachments,
  //         //       attachments: detail?.attachments,
  //         //     }))
  //         // };
  //         // --------- code commented -------------
  //         // this.promptCreateService.getPreSignedUrl(preSignedUrlRequest).subscribe(res => {
  //         //   if(res.status_code === 200) {
  //         //     const { prompt_details } = res?.data;
  //         //     prompt_details?.forEach((detail: any) => {
  //         //       detail?.permanent_attachments?.forEach((attachment: any) => {
  //         //         const file = this.promptDetails.perminentAttachments?.find((file: any) => file?.name === attachment?.file_name)
  //         //         this.promptCreateService.uploadFileToS3(attachment.url, file).subscribe(res => {
  //         //         })
  //         //       })
  //         //       detail?.attachments?.forEach((attachment: any) => {
  //         //         const file = this.promptDetails.attachments?.find((file: any) => file?.name === attachment?.file_name)
  //         //         this.promptCreateService.uploadFileToS3(attachment.url, file).subscribe(res => {
  //         //         })
  //         //       })
  //         //     })
  //         //   }
  //         // })

  //         // -------------------- code for upload to s3 using presigned url -----
  //         if (res?.data?.prompt_details) {

  //           res?.data?.prompt_details?.forEach((each_prompt_detail: { permanent_attachments: any[]; id: any; attachments: any[]; }) => {

  //             let newTempPerAttach: any = [];
  //             this.permentattchData.forEach((item: any) => {
  //               if (item.file_type) {
  //                 newTempPerAttach.push(item.selected.name);
  //               }
  //             });
  //             if (newTempPerAttach.length > 0) {
  //               each_prompt_detail?.permanent_attachments.forEach(each_permanent_attachments => {
  //                 if (newTempPerAttach.includes(each_permanent_attachments)) {
  //                   const presSignedUrlRequest = {
  //                     prompt_id: res?.data?.prompt?.id,
  //                     title: res?.data?.prompt?.title,
  //                     url_type: 'put_object',
  //                     prompt_detail_id: each_prompt_detail?.id,
  //                     attachment_type: "permanent_attachments",
  //                     file_name: each_permanent_attachments,
  //                     user_id: this.userid
  //                   }
  //                   this.promptCreateService.getPresignedUrl(presSignedUrlRequest).subscribe(response => {
  //                     if (response?.data) {
  //                       const presignedUrl = response?.data?.url;
  //                       const file = this.permentattch?.find((file: any) => file.selected.name === each_permanent_attachments)
  //                       this.promptCreateService.uploadFileToS3(presignedUrl, file.selected!).subscribe({
  //                         next: (res) => {
  //                           // alert("File uploaded successfully");
  //                         },
  //                         error: (error) => {
  //                           console.error("Error uploading file:", error);
  //                           // alert("File upload failed");
  //                         }
  //                       });

  //                     } else {
  //                     }
  //                   })
  //                 }
  //               })
  //             }

  //             let newTempAttach: any = [];
  //             this.attachmentData.forEach((item: any) => {
  //               if (item.type) {
  //                 newTempAttach.push(item.name);
  //               }
  //             });
  //             if (newTempAttach.length > 0) {
  //               each_prompt_detail?.attachments.forEach(each_attachments => {
  //                 if (newTempAttach.includes(each_attachments)) {
  //                   const presSignedUrlRequest = {
  //                     prompt_id: res?.data?.prompt?.id,
  //                     title: res?.data?.prompt?.title,
  //                     url_type: 'put_object',
  //                     prompt_detail_id: each_prompt_detail?.id,
  //                     attachment_type: "attachments",
  //                     file_name: each_attachments,
  //                     user_id: this.userid
  //                   }
  //                   this.promptCreateService.getPresignedUrl(presSignedUrlRequest).subscribe(response => {
  //                     if (response?.data) {
  //                       const presignedUrl = response?.data?.url;
  //                       const file = this.attch?.find((file: any) => file.selected.name === each_attachments)

  //                       this.promptCreateService.uploadFileToS3(presignedUrl, file.selected!).subscribe({
  //                         next: (res) => {
  //                           newTempAttach = [];
  //                         },
  //                         error: (error) => {
  //                           console.error("Error uploading file:", error);
  //                           // alert("File upload failed");
  //                         }
  //                       });
  //                     } else {
  //                     }
  //                   })
  //                 }
  //               })
  //             }
  //           })
  //         }

  //       } else {
  //         this.promptDetailsObj = []
  //       }
  //     }, (error: any) => {
  //       let text = error?.error?.message;
  //       let wordLimit = 15;
  //       let msg = text.split(/\s+/).slice(0, wordLimit).join(" ") + (text.split(/\s+/).length > wordLimit ? " ..." : "")
  //       if (error?.status === 409) {
  //         this.dialogRef?.close({});
  //         this.openSnackbar(msg, 'Title already exists', 'Error Message');
  //       }

  //     });



  //   }




  // }




  async onSave(event: any) {
    this.isSaveClicked = false
    if (this.subCategory?.id) {
      this.subCategory = { id: this.subCategory?.id, name: this.subCategory?.name, value: this.subCategory };
    }
    if (!this.promptTitle.value || !this.category?.value || (this.category?.value?.subcategories?.length > 0 && this.subCategory == null) || (this.category?.value?.subcategories?.length > 0 && this.subCategory == undefined)) {
      this.isSaveClicked = true
      return; // Stop execution if validation fails
    }


    // if(this.forType == 'variant' &&  this.promptTitle.value == this.data.title){
    //   this.dialogRef?.close({});
    //   this.openSnackbar('title title should update.', 'Error Message', 'Error Message');
    //   return;
    // }

    if (this.forType == 'variant') {
      if (!this.variant_reason.value) {
        this.isSaveClicked = true
        return;
      }
    } else {
      if ((this.versionStatus || this.version > 0) && !this.version_reason.value) {
        this.isSaveClicked = true
        return;
      }

    }
    
    // if  (this.promptTitle.value == '' || this.category.value == null || (this.subcategories?.length > 0 && this.subCategory?.value == null)) {
    //   this.isSaveClicked = true
    //   return;
    // }

    // let obj = {

    //       "prompt_name": this.title,
    //       "prompt": this.promptDetails.promptDetails,
    //       "input": this.promptDetails.promptInput,
    //       "order_number": 1,
    //       "model_id": 2,
    //       "permanent_attachments": this.promptDetails.perminentAttachments?.map((attachment: any) => attachment?.name),
    //       "attachments": this.promptDetails.attachments?.map((attachment: any) => attachment?.name),
    //       "variables": [
    //         "c7",
    //         ["c7_1", "c7_2"]
    //       ]
    //     }

    if (this.versionStatus) {
      Object.keys(this.promptDetailsObj).forEach(key => {
        this.promptDetailsObj[key].prompt_detail_id = null;
      });
    }

    let request = {};

    //     this.promptDetailsObj.push(obj)
    if (this.forType == 'variant') {
      request = {
        "title": this.promptTitle.value,
        "description": this.description.value ?? '',
        "notes": this.notes.value ?? '',
        "category_id": this.category?.value?.id || this.category?.value,
        "sub_category_id": this.subCategory?.value?.id ?? null,
        "user_id": +this.userid,
        "action_type": 'save',
        "prompt_type": this.promptDetailsObj.length == 1 ? "normal" : 'chain',
        "prompt_id": this.versionStatus ? null : this.promptId,//this.promptId ?? null, 
        "prompt_details": this.promptDetailsObj,
        //this.versionStatus?this.promptDetailsObj?.prompt_details?.forEach((data:any)=> {data.prompt_detail_id=null;}):this.promptDetailsObj,
        "lastselectedTabIndex": this.lastSelectedTabIndex,
        "variant": this.data?.variant + 1,
        "variant_reason": this.variant_reason.value ?? '',
        "variant_source": this.data?.promptId,
        "estimated_time": this.timeFloat
      }
    } else {
      request = {
        "title": this.promptTitle.value,
        "description": this.description.value ?? '',
        "notes": this.notes.value ?? '',
        "category_id": this.category?.value?.id || this.category?.value,
        "sub_category_id": this.subCategory?.value?.id ?? null,
        "user_id": +this.userid,
        "action_type": 'save',
        "prompt_type": this.promptDetailsObj.length == 1 ? "normal" : 'chain',
        "prompt_id": this.versionStatus ? null : this.promptId,//this.promptId ?? null, 
        "prompt_details": this.promptDetailsObj,
        //this.versionStatus?this.promptDetailsObj?.prompt_details?.forEach((data:any)=> {data.prompt_detail_id=null;}):this.promptDetailsObj,
        "lastselectedTabIndex": this.lastSelectedTabIndex,
        "version": this.versionStatus ? this.data?.latest_version + 1 : this.data?.version,
        "version_reason": this.version_reason.value ?? '',
        "source_prompt_id": this.data?.source_prompt_id,
        "source_version": this.data?.source_version,
        "variant": this.data?.variant,
        "variant_reason": this.data?.variant_reason ?? '',
        "variant_source": this.data?.variant_source_id,
        "estimated_time": this.timeFloat
      }

    }


    if (((this.versionStatus && this.forType == 'version') || (!this.versionStatus && this.version > 0))) {
      let version = this.versionStatus ? (this.data?.latest_version + 1) : this.data?.version;
      this.subTitle += ' version ' + version;
    } else if (this.forType == 'variant' || this.variant > 0) {
      this.subTitle += ' variant ' + (this.data?.variant + 1);
    }


    //return;
    // if  (this.promptTitle.value == '' || this.category.value == null || (this.subcategories?.length > 0 && this.subCategory?.value == null)) {
    //   this.isSaveClicked = true
    //   return;
    // } 
    if (this.promptDetailsObj) {

      try {
        const res: any = await this.promptCreateService.OnSave(request).toPromise();
        if (res.status_code === 200) {
          this.promptCreateService.promptSaveResp$.next(res.data)

          let messageData;
          const variant = res?.data?.prompt?.variant;
          const version = res?.data?.prompt?.version;
          const promptTitle = this.promptTitle?.value;
          if (res?.data?.prompt?.estimated_time) {
            let float_time = parseFloat(res?.data?.prompt?.estimated_time).toFixed(2);
            this.time = float_time;
          }
          if (this.promptDetailsObj && this.promptDetailsObj.length > 1) {
            // messageData = `The prompt chain '${this.promptUserDetails?.title}' has been approved and published successfully`
            messageData = `The prompt chain `;
            if ((variant >= 1) && (version >= 1)) {
              messageData += `'${promptTitle} - Variant ${variant} Version ${version}'`;
            } else if ((variant >= 1) && (version < 1)) {
              messageData += `'${promptTitle} - Variant ${variant}'`;
            } else if ((version >= 1 && (variant < 1))) {
              messageData += `'${promptTitle} - Version ${version}'`;
            } else {
              messageData += `'${promptTitle}'`;
            }
            messageData += ' has been saved successfully';
          } else if (this.promptDetailsObj && this.promptDetailsObj.length == 1) {
            // messageData = `The prompt '${this.promptUserDetails?.title}' has been approved and published successfully`
            messageData = `The prompt `;
            if ((variant >= 1) && (version >= 1)) {
              messageData += `'${promptTitle} - Variant ${variant} Version ${version}'`;
            } else if ((variant >= 1) && (version < 1)) {
              messageData += `'${promptTitle} - Variant ${variant}'`;
            } else if ((version >= 1 && (variant < 1))) {
              messageData += `'${promptTitle} - Version ${version}'`;
            } else {
              messageData += `'${promptTitle}'`;
            }
            messageData += ' has been saved successfully';
          }

          const dialogRef = this.dialog.open(ErrorNotficationComponent, {
            data: {
              message: messageData,
              title: "Prompt Saved successfully",
              action_type: 'add',
              cssClass: 'success-snackbar'
            }
          });
          if (this.isInsert) {
            setTimeout(() => {
              dialogRef.close();
            }, 1000)
          }
          // const dialogRef = this.dialog.open(SaveSuccessComponent,{
          //   data:{
          //     message:this.promptTitle.value,
          //     title:"Prompt Saved successfully",
          //     action_type: 'save'
          //   }
          // }); 
          // this.dialogRef?.close(res);
          // const preSignedUrlRequest = {
          //   prompt_id: res?.data?.prompt?.id,
          //   title: res?.data?.prompt?.title,
          //   url_type: 'put_object',
          //   prompt_details: res?.data?.prompt_details?.map((detail: any) =>
          //     ({
          //       prompt_detail_id: detail?.id,
          //       permanent_attachments: detail?.permanent_attachments,
          //       attachments: detail?.attachments,
          //     }))
          // };
          // --------- code commented -------------
          // this.promptCreateService.getPreSignedUrl(preSignedUrlRequest).subscribe(res => {
          //   if(res.status_code === 200) {
          //     const { prompt_details } = res?.data;
          //     prompt_details?.forEach((detail: any) => {
          //       detail?.permanent_attachments?.forEach((attachment: any) => {
          //         const file = this.promptDetails.perminentAttachments?.find((file: any) => file?.name === attachment?.file_name)
          //         this.promptCreateService.uploadFileToS3(attachment.url, file).subscribe(res => {
          //         })
          //       })
          //       detail?.attachments?.forEach((attachment: any) => {
          //         const file = this.promptDetails.attachments?.find((file: any) => file?.name === attachment?.file_name)
          //         this.promptCreateService.uploadFileToS3(attachment.url, file).subscribe(res => {
          //         })
          //       })
          //     })
          //   }
          // })

          // -------------------- code for upload to s3 using presigned url -----
          if (res?.data?.prompt_details) {

            let s3Uploadpromise = res?.data?.prompt_details?.map(async (each_prompt_detail: { permanent_attachments: any[]; id: any; attachments: any[]; }) => {

              // let newTempPerAttach: any = [];
              // this.permentattchData.forEach((item: any) => {
              //   if (item.file_type) {
              //     newTempPerAttach.push(item.selected.name);
              //   }
              // });
              // if (newTempPerAttach.length > 0) {
              //   each_prompt_detail?.permanent_attachments.forEach(async each_permanent_attachments => {
              //     if (newTempPerAttach.includes(each_permanent_attachments)) {
              //       const presSignedUrlRequest = {
              //         prompt_id: res?.data?.prompt?.id,
              //         title: res?.data?.prompt?.title,
              //         url_type: 'put_object',
              //         prompt_detail_id: each_prompt_detail?.id,
              //         attachment_type: "permanent_attachments",
              //         file_name: each_permanent_attachments,
              //         user_id: this.userid
              //       }

              //       try {
              //         const response = await this.promptCreateService.getPresignedUrl(presSignedUrlRequest).toPromise();
              //         if (response?.data) {
              //           const presignedUrl = response.data.url;
              //           const file = this.permentattch?.find((file: any) => file.selected.name === each_permanent_attachments)
              //           await this.promptCreateService.uploadFileToS3(presignedUrl, file.selected!).toPromise();
              //         }
              //       } catch (err) {
              //         console.error("Error uploading file:", err);
              //       }
              //       // this.promptCreateService.getPresignedUrl(presSignedUrlRequest).subscribe(response => {
              //       //   if (response?.data) {
              //       //     const presignedUrl = response?.data?.url;
              //       //     const file = this.permentattch?.find((file: any) => file.selected.name === each_permanent_attachments)
              //       //     this.promptCreateService.uploadFileToS3(presignedUrl, file.selected!).subscribe({
              //       //       next: (res) => {
              //       //         // alert("File uploaded successfully");
              //       //       },
              //       //       error: (error) => {
              //       //         console.error("Error uploading file:", error);
              //       //         // alert("File upload failed");
              //       //       }
              //       //     });

              //       //   } else {
              //       //   }
              //       // })
              //     }
              //   })
              // }

              let newTempAttach: any = [];
              this.attachmentData.forEach((item: any) => {
                if (item.type) {
                  newTempAttach.push(item.name);
                }
              });
              if (newTempAttach.length > 0) {
                const uploadPromises = each_prompt_detail?.attachments.map(async each_attachments => {
                  if (newTempAttach.includes(each_attachments)) {
                    const presSignedUrlRequest = {
                      prompt_id: res?.data?.prompt?.id,
                      title: res?.data?.prompt?.title,
                      url_type: 'put_object',
                      prompt_detail_id: each_prompt_detail?.id,
                      attachment_type: "attachments",
                      file_name: each_attachments,
                      user_id: this.userid
                    }

                    try {
                      const response = await this.promptCreateService.getPresignedUrl(presSignedUrlRequest).toPromise();
                      if (response?.data) {
                        const presignedUrl = response.data.url;
                        const file = this.attch?.find((file: any) => file.selected.name === each_attachments)
                        await this.promptCreateService.uploadFileToS3(presignedUrl, file.selected!).toPromise();
                      }
                    } catch (err) {
                      // console.error("Error uploading file:", err);
                    }

                    // this.promptCreateService.getPresignedUrl(presSignedUrlRequest).subscribe(response => {
                    //   if (response?.data) {
                    //     const presignedUrl = response?.data?.url;
                    //     const file = this.attch?.find((file: any) => file.selected.name === each_attachments)

                    //     this.promptCreateService.uploadFileToS3(presignedUrl, file.selected!).subscribe({
                    //       next: (res) => {
                    //         newTempAttach = [];
                    //       },
                    //       error: (error) => {
                    //         console.error("Error uploading file:", error);
                    //         // alert("File upload failed");
                    //       }
                    //     });
                    //   } else {
                    //   }
                    // })
                  }
                })
                await Promise.all(uploadPromises); 
                // this.dialogRef?.close(res);
              } else {
                // this.dialogRef?.close(res);
              }
            })
            await Promise.all(s3Uploadpromise); 
            this.dialogRef?.close(res);
          } else {
            this.promptDetailsObj = []
            this.dialogRef?.close(res);
          }
        }

      } catch (error: any) {
        console.error("Save error: ", error);
        let text = error?.error?.message;
        let wordLimit = 15;
        let msg = text.split(/\s+/).slice(0, wordLimit).join(" ") + (text.split(/\s+/).length > wordLimit ? " ..." : "")
        if (error?.status === 409) {
          this.dialogRef?.close({});
          this.openSnackbar(msg, 'Title already exists', 'Error Message');
        }
      }
    }
  }




  openSnackbar(message: string, title: string, cssClass: string) {
    // this.snackBar.openFromComponent(SnackBarComponent, {
    //   data: { message: message, type: type },
    //   duration: 3000, // Duration in milliseconds,
    //   horizontalPosition: 'center',
    //   verticalPosition: 'top',
    //   panelClass: [cssClass],
    // });
    const dialogRef = this.dialog.open(ErrorNotficationComponent, {
      data: {
        message: message,
        title: title,
        action_type: 'add',
        cssClass: cssClass
      }
    });
  }
}
